import { AccountsApiService } from '@accounts/domain';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordApiService extends AccountsApiService {
  resetPassword(newPassword: string, resetToken: string): Observable<any> {
    return this._put('/v1/accounts/auth/reset_password', {
      password: newPassword,
      reset_token: resetToken,
    }).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => throwError(res)),
    );
  }
}
